import React, { useContext } from 'react'
import classnames from 'classnames'
import imgResize from '@/utils/img-resize-pad'
import { formatMoney } from '@/utils'
import { LocalEum } from '@/constant'
import { ListTypeEnum, ProductItemType } from '../../types'
import context, { ProductContext } from '../../context'
import { isDuApp, compareVersion, getAppVersion } from '@/utils/appUtils/getDevice'
import Jockeys from '@/utils/jockey'
import { copyText } from '@/utils/index'
import { Toast } from 'antd-mobile'
import appInstall from '@/utils/appUtils/appInstall'
import { downAndUpArrow } from '../../constants'

import {
  upIcon,
  newsUpDisableIcon,
  saleUpDisableIcon,
  newsUpIcon,
  saleUpIcon,
} from '../../constants'

import styles from './index.module.less'
import { handleBreakCode } from '..'

const isTop3ColorList = [
  { background: 'rgb(245, 245, 249)', color: 'rgb(127, 127, 142)' },
  { background: 'rgba(255, 70, 87, 0.1)', color: 'rgb(255, 70, 87)' },
]

interface CommonHotShowType {
  data: ProductItemType
}

function useHotShowNewsAndSale({
  isTop3,
  top3Icon,
  notTop3Icon,
}: {
  isTop3: boolean
  top3Icon: string
  notTop3Icon: string
}) {
  const styles = isTop3ColorList[Number(isTop3)]
  const useImg = isTop3 ? top3Icon : notTop3Icon
  return {
    imgSrc: useImg,
    styles,
  }
}

function UpHotShow({ data }: CommonHotShowType) {
  return (
    <div
      className={classnames({
        [styles['hot-show-common']]: true,
        [styles['up-hot-show']]: true,
      })}
    >
      <span className={styles['size-wrapper']}>{data.spuSize}</span>
      <span className={styles['percentage-wrapper']}>
        {/* <span className={styles['percentage-pre']}>{`${data.topIndexDes}`}</span> */}
        <img className={styles['up-icon']} src={upIcon} alt="" />
        <span className={styles['percentage']}>{`${data.topIndex}`}</span>
      </span>
    </div>
  )
}

/**
 * 元素类名暂用 sale榜，以防后续需求变更
 * @param param0
 */
function SaleAndNewsHotShow({
  data,
  isTop3,
  top3Icon,
  notTop3Icon,
  hotFont,
}: CommonHotShowType & {
  isTop3: boolean
  top3Icon: string
  notTop3Icon: string
  hotFont: string
}) {
  const { styles: divStyle, imgSrc } = useHotShowNewsAndSale({
    isTop3,
    top3Icon,
    notTop3Icon,
  })
  return (
    <div
      className={classnames({
        [styles['hot-show-common']]: true,
        [styles['sale-hot-show']]: true,
      })}
    >
      <div style={divStyle} className={styles['sale-hot-show-content']}>
        <img className={styles['icon-img']} src={imgSrc} alt="" />
        <span className={styles['hot-font']}>{hotFont}</span>
        <span className={styles['hot-index']}>{data.topIndex}</span>
      </div>
    </div>
  )
}

function HotLine({
  data,
  isTop3,
  listType,
}: {
  data: ProductItemType
  isTop3: boolean
  listType: number
}) {
  const { langConfig } = useContext(context)
  if (listType === ListTypeEnum.up) {
    return <UpHotShow data={data} />
  }

  if (listType === ListTypeEnum.sale) {
    return (
      <SaleAndNewsHotShow
        top3Icon={saleUpIcon}
        notTop3Icon={saleUpDisableIcon}
        hotFont={langConfig[ListTypeEnum.sale].hotFont}
        data={data}
        isTop3={isTop3}
      />
    )
  }

  return (
    <SaleAndNewsHotShow
      top3Icon={newsUpIcon}
      notTop3Icon={newsUpDisableIcon}
      data={data}
      isTop3={isTop3}
      hotFont={langConfig[ListTypeEnum.news].hotFont}
    />
  )
}
function goDetail(spuId: any, itemNo: any) {
  if (isDuApp() && compareVersion(getAppVersion(), '2.1.5') !== -1) {
    Jockeys.openNativePage('/sell/productDetail', {
      spuId,
    })
    return
  }

  if (isDuApp()) {
    const msg = '貨號已複製，暫僅可在首頁粘貼並搜索。'
    copyText(itemNo)
    Toast.info(msg)
    return
  }

  appInstall('/sell/productDetail', { spuId })
}
function ProductItem(props: {
  data: ProductItemType
  topIconSrc: string
  index: number
  currencyCode: string
  local: LocalEum
  isTop3: boolean
  listType: number
  langConfig: any
}) {
  const { trackHelper, handleTrack } = useContext(context)
  const { data, topIconSrc, index, currencyCode, isTop3, listType, langConfig } = props

  const handleClick = (e) => {
    e.stopPropagation()
    handleBreakCode(langConfig, data.breakCodeTag, data.spuId, trackHelper)
    trackHelper('poizon_common_exposure', {
      current_page: 515,
      block_type: 3280,
      spu_id: data.spuId,
    })
  }
  return (
    <div
      className={styles['product-item']}
      data-spu-id={data.spuId}
      data-index={index}
      onClick={() => {
        goDetail(data.spuId, data.spuId)
        handleTrack(index, data.spuId)
      }}
    >
      <div className={styles['left-img-wrapper']}>
        <div className={styles['top-icon-wrapper']}>
          <img src={topIconSrc} alt="" className={styles['top-icon']} />
          <div className={styles['top-index']}>{index + 1}</div>
        </div>
        <img
          data-layzload-src={imgResize(data.spuLogoUrl, 160)}
          alt=""
          className={styles['prod-img']}
        />
      </div>
      <div className={styles['right-content']}>
        <div className={styles['right-content-title']}>{data.spuName}</div>
        <div className={styles['label-wrapper']}>
          <HotLine data={data} isTop3={isTop3} listType={listType} />
          {data?.breakCode && (
            <div className={styles['break-code']} onClick={handleClick}>
              {(langConfig as any).breakCode}
            </div>
          )}
        </div>
        {/* <UpHotShow data={data} /> */}
        <div className={styles['price-wrapper']}>
          <div className={styles['currency-code']}>{currencyCode}</div>
          <div className={styles['money']}>{formatMoney(data.price, true)}</div>
        </div>
      </div>

      <div className={styles['layer-select']}>
        <img className={styles['select-icon']} src={downAndUpArrow} alt="" width="16" />
      </div>
    </div>
  )
}

function getTopIconByIndex(index: number, { top1Icon, top2Icon, top3Icon, otherIcon }) {
  const arr = [top1Icon, top2Icon, top3Icon, otherIcon]
  return arr[index - 1] || otherIcon
}

interface Props {
  dataSource: ProductItemType[]
  listType: number
}

function ProductList(props: Props) {
  const { dataSource, listType } = props
  const { top1Icon, top2Icon, top3Icon, otherIcon, currencyCode, local, langConfig } = useContext(
    ProductContext
  )
  return (
    <div
      className={classnames({
        [styles['product-list-wrapper']]: true,
        // [styles['product-list-wrapper_unactive']]: !isActive,
      })}
    >
      {dataSource?.map((ele, i) => {
        const topIconSrc = getTopIconByIndex(i + 1, {
          top1Icon,
          top2Icon,
          top3Icon,
          otherIcon,
        })
        const isTop3 = i <= 2
        return (
          <ProductItem
            index={i}
            topIconSrc={topIconSrc}
            data={ele}
            key={`${ele.spuId}${ele.skuId}`}
            currencyCode={currencyCode}
            local={local}
            isTop3={isTop3}
            listType={listType}
            langConfig={langConfig}
          />
        )
      })}
    </div>
  )
}

export default React.memo(ProductList)
